type ReactRouterManifestWindow = Window & {
    __reactRouterManifest?: { entry: { module: string } };
};

const getServerVersion = async (): Promise<string | undefined> => {
    try {
        // BB-3514: react-router v7 renamed the client manifest global from
        // `__remixManifest` to `__reactRouterManifest`. Reading the old name
        // silently returned undefined and broke deploy-reload version detection.
        const manifest = (window as ReactRouterManifestWindow)
            .__reactRouterManifest?.entry.module;
        if (!manifest) {
            return undefined;
        }
        const buildPath = manifest?.match(/(.*)[/\\]/)?.[1];
        const ARCHIPRO_VERSION_PATH =
            `${buildPath}/version.json?t=${Date.now()}` + Date.now();
        const response = await fetch(ARCHIPRO_VERSION_PATH);
        if (response.ok) {
            // Might want to consider removing and just relying on the header?
            const data = await response.json();
            return data?.version;
        }
    } catch {
        return;
    }
    return undefined;
};

export { getServerVersion };
